'use client'

import styles from './Breadcrumb.module.scss'

import React, { useMemo } from 'react'

import ErrorBoundary from 'UtilityComponents/ErrorBoundary'
import ClassNames from 'classnames'

import Gutters from 'Atoms/Gutters'
import TextLink from 'Atoms/TextLink'
import Typography from 'Atoms/Typography'

const Breadcrumb = ({ breadcrumb, minifyMobile = true, prp_layout = false, className }) => {
  breadcrumb = breadcrumb.filter((item) => item)

  return (
    <ErrorBoundary>
      <Gutters
        className={ClassNames(styles.pdp_layout_breadcrumb, styles.hideMobile, className)}
        noVerticalPadding
        role={'navigation'}
        aria-label={'desktop breadcrumb'}
      >
        <span>
          {useMemo(
            () =>
              breadcrumb
                .sort((a, b) => {
                  return parseInt(a.ordinality) - parseInt(b.ordinality)
                })
                .map((item, i) => (
                  <ErrorBoundary key={`breadcrumb_${item && item.displayText ? item.displayText : ''}_${i}`}>
                    {item && item.url ? (
                      <TextLink
                        size={0.75}
                        tone={'subtle'}
                        inline
                        href={item.url}
                        data-testid={`bc_link_desktop_${item.displayText}`}
                      >
                        {item.displayText}
                      </TextLink>
                    ) : (
                      <Typography
                        size={0.75}
                        tone={'subtle'}
                        inline
                        font={'bold'}
                        data-testid={`bc_type_desktop_${item.displayText}`}
                      >
                        {item.displayText}
                      </Typography>
                    )}
                    {i !== breadcrumb.length - 1 ? (
                      <Typography className={styles.breadcrumb_spacer} size={0.75} tone={'subtle'} inline>
                        {'/'}
                      </Typography>
                    ) : (
                      false
                    )}
                  </ErrorBoundary>
                )),
            [breadcrumb],
          )}
        </span>
      </Gutters>
      <div className={prp_layout ? styles.prp_layout : ''}>
        <Gutters
          className={
            prp_layout
              ? ClassNames(styles.prp_layout_breadcrumb, styles.pdp_layout_breadcrumb, styles.hideDesktop)
              : ClassNames(styles.pdp_layout_breadcrumb, styles.hideDesktop)
          }
          noVerticalPadding
          noRightPadding
          role={'navigation'}
          aria-label={'mobile breadcrumb'}
        >
          {useMemo(
            () =>
              breadcrumb
                .slice(minifyMobile ? 1 : 0, breadcrumb.length)
                .sort((a, b) => {
                  return parseInt(a.ordinality) - parseInt(b.ordinality)
                })
                .map((item, i) => (
                  <ErrorBoundary key={`breadcrumb_${item && item.displayText ? item.displayText : ''}_${i}`}>
                    {item && item.url ? (
                      <TextLink
                        size={0.75}
                        tone={'subtle'}
                        inline
                        href={item.url}
                        data-testid={`bc_link_mobile_${item.displayText}`}
                      >
                        {item.displayText}
                      </TextLink>
                    ) : (
                      <Typography
                        size={0.75}
                        tone={'subtle'}
                        inline
                        font={'bold'}
                        data-testid={`bc_type_mobile_${item.displayText}`}
                      >
                        {item.displayText}
                      </Typography>
                    )}
                    {i !== breadcrumb.length - (minifyMobile ? 2 : 1) ? (
                      <Typography className={styles.breadcrumb_spacer} size={0.75} tone={'subtle'} inline>
                        {'/'}
                      </Typography>
                    ) : (
                      false
                    )}
                  </ErrorBoundary>
                )),
            [breadcrumb],
          )}
        </Gutters>
      </div>
    </ErrorBoundary>
  )
}

export default Breadcrumb
